import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectAllPositions } from '../../store/positionsSlice';
import { selectAllEntities } from '../../store/entitiesSlice';
import { removePosition } from '../../store/positionsSlice';
import { incrementBalance } from '../../store/accountSlice';
import { addTransaction } from '../../store/transactionsSlice';
import { current } from '@reduxjs/toolkit';
import { closePositionAPI } from '../api'; // Assuming this is the API call to close a position
import { selectCommodities } from '../../store/commoditiesSlice';

const UserPositions = ({refreshData}) => {
  const dispatch = useDispatch();
  const positions = useSelector(selectAllPositions);
  const entities = useSelector(selectCommodities);
  const user = useSelector(state => state.user.user);

  const getCurrentPrice = (entityId, type) => {
    const entity = entities.find(e => e.id === entityId);
    if (!entity) return null;
    // For buy order type, use bid; for sell, use ask
    return type === 'buy' ? entity.bid : entity.ask;
  };

  const calculateProfitLoss = (type, currentValue, openingValue) => {
    if (currentValue === null) return null;
    return type === 'buy' ? (currentValue - openingValue) : (openingValue - currentValue);
  }

  const callClosePosition = async (positionId) => {
      await closePositionAPI(positionId);
      refreshData(user, dispatch);
  };

  const handleClosePosition = (pos) => {
    callClosePosition(pos.id);
  };

  if (!positions.length) {
    return (
      <div style={{ color: '#666', fontStyle: 'italic', marginTop: 12 }}>
        No positions yet.
      </div>
    );
  }

  return (
    <div style={{ marginTop: 24 }}>
      <h4 style={{ marginBottom: 12, color: '#1976d2' }}>Open User Positions</h4>
      <table style={{ width: '100%', borderCollapse: 'collapse', background: '#f8fafd' }}>
        <thead>
          <tr style={{ background: '#e3eaf2' }}>
            <th style={{ padding: 8, border: '1px solid #ddd' }}>Entity</th>
            <th style={{ padding: 8, border: '1px solid #ddd' }}>Unit</th>
            <th style={{ padding: 8, border: '1px solid #ddd' }}>Type</th>
            <th style={{ padding: 8, border: '1px solid #ddd' }}>Quantity</th>
            <th style={{ padding: 8, border: '1px solid #ddd' }}>Price</th>
            <th style={{ padding: 8, border: '1px solid #ddd' }}>Current Price</th>
            <th style={{ padding: 8, border: '1px solid #ddd' }}>Current Value</th>
            <th style={{ padding: 8, border: '1px solid #ddd' }}>Profit / Loss</th>
            <th style={{ padding: 8, border: '1px solid #ddd' }}>Close Position</th>
          </tr>
        </thead>
        <tbody>
          {positions.map(pos => {
            const currentPrice = getCurrentPrice(pos.entityId, pos.type);
            const currentValue = currentPrice ? (currentPrice * pos.quantity) : null;
            const openingValue = pos.price * pos.quantity;
            const profitLoss = (currentValue !== null) ? pos.type === 'buy' 
            ? (currentValue - openingValue) 
            : (openingValue - currentValue) : null;
            return (
              <tr key={pos.orderId}>
                <td style={{ padding: 8, border: '1px solid #ddd' }}>{pos.entityName}</td>
                <td style={{ padding: 8, border: '1px solid #ddd' }}>{pos.unit || '-'}</td>
                <td style={{ padding: 8, border: '1px solid #ddd', textTransform: 'capitalize' }}>{pos.type}</td>
                <td style={{ padding: 8, border: '1px solid #ddd' }}>{pos.quantity}</td>
                <td style={{ padding: 8, border: '1px solid #ddd' }}>${pos.price?.toFixed(2)}</td>
                <td style={{ padding: 8, border: '1px solid #ddd' }}>{currentPrice !== null ? `$${currentPrice.toFixed(2)}` : '-'}</td>
                <td style={{ padding: 8, border: '1px solid #ddd' }}>{currentValue !== null ? `$${currentValue.toFixed(2)}` : '-'}</td>
                <td style={{ padding: 8, border: '1px solid #ddd', color: profitLoss > 0 ? '#388e3c' : profitLoss < 0 ? '#d32f2f' : '#666', fontWeight: 'bold' }}>
                  {profitLoss !== null ? `${profitLoss >= 0 ? '+' : ''}$${profitLoss.toFixed(2)}` : '-'}
                </td>
                <td style={{ padding: 8, border: '1px solid #ddd' }}>
                  {pos.status === 'open' ?
                  <button
                    onClick={() => handleClosePosition(pos)}
                    style={{ padding: '6px 14px', background: '#1976d2', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontWeight: 'bold' }}
                  >
                    Close
                  </button>
                  : null
                  }
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default UserPositions;
